<style lang="less" scoped>
</style>

<template>
  <div class="cx-layout" ref="layout">
    <slot></slot>
  </div>
</template>

<script>
/* 组件-布局 */
export default
{

  /**
   * 调用说明：
   * @prop  {Boolean} [gutters = false]           region之间是否有间距
   */
  props:
  {
    gutters: {type: Boolean, default: false}
  },
  data()
  {
    return {
      regions:
      [
        {com: null, size: 0},               //north
        {com: null, size: 0},               //west
        {com: null, size: 0},               //east
        {com: null, size: 0},               //south
        {com: null, size: 0}                //center
      ],
      spliters:
      []
    }
  },
  mounted()
  {
    if (cx.resizes)
      cx.resizes.add(this)
    this.init()
    this.onResize()
  },
  beforeDestroy()
  {
    if (cx.resizes)
      cx.resizes.remove(this)
  },
  methods:
  {
    /**
     * 初始化对象
     * @method
     */
    init()
    {
      let child, region, split
      //初始化 region
      for (child of this.$children)
      {
        if (child.index === undefined || child.index < 0 || child.index > 4)
          continue
        region = this.regions[child.index]
        region.com = child

        if (child.split)
        {
          split =
          {
            region: child.region,
            index: child.index
          }
          this.spliters.push(split)
        }
      }
    },
    /**
     * 消息响应函数-窗口大小发生变化
     * @method
     */
    onResize()
    {
      let item
      //取每个Region的大小
      for (item of this.regions)
      {
        if (!item.com)
          continue
        item.size = parseInt(item.com.getSize())
      }
      //设置 region 的位置与大小
      for (item of this.regions)
      {
        if (!item.com)
          continue
        item.com.setPosSize(this.regions, this.gutters)
      }
      //设置 spliter 的位置与大小
      for (item of this.spliters)
        this.getSplitSize(item)
      //更新下面组件的大小
      this.$nextTick(() =>
      {
        let region, child2
        for (region of this.regions)
        {
          if (!region.com)
            continue
          for (child2 of region.com.$children)
          {
            if (child2.onResize)
              child2.onResize()
          }
        }
      })
    },
    update()
    {
      setTimeout(() =>
      {
        this.onResize()
      }, 0)
    },
    /**
     * 计算分隔条的位置 / 大小
     * @method
     * @param   {Object}    spliter         分隔条信息
     * @returns
     */
    getSplitSize(spliter)
    {
      let north = this.regions[0]       //cx.consts.REG_NORTH
      let west = this.regions[1]        //cx.consts.REG_WEST
      let east = this.regions[2]        //cx.consts.REG_EAST
      let south = this.regions[3]       //cx.consts.REG_SOUTH
      switch (spliter.index)
      {
      case 0:   //cx.consts.REG_NORTH
        spliter.top = north.size + 1
        break
      case 3:   //cx.consts.REG_SOUTH
        spliter.bottom = south.size + 1
        break
      case 1:   //cx.consts.REG_WEST
        spliter.left = west.size + 1
        spliter.top = north.size + 1
        spliter.bottom = south.size + 1
        break
      case 2:   //cx.consts.REG_EAST
        spliter.right = east.size + 1
        spliter.top = north.size + 1
        spliter.bottom = south.size + 1
        break
      }
    },
    startSplit(evt, dom, index)
    {
      this.splitObj = new cx.LayoutSplit(this.$el, this, dom, index, evt.clientX, evt.clientY)
    },
    endSplit(index, deltaSize)
    {
      let region, size
      delete this.splitObj
      region = this.regions[index]
      size = region.size + deltaSize
      region = region.com
      region.autoSize = false
      region.size = size
      this.onResize()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/com/Layout.vue